// ============================================================================
// HEBREW TRANSLATIONS - BIBLE TREASURES
// ============================================================================
// אוצרות רוחניים מהדבר

export const bibleTreasuresHe = [
  {
    type: "perle_sagesse",
    content: "חוכמה קדושה אינה תיאוריה מופשטת, אלא חיים קונקרטיים המתגלים בבחירות היומיומיות שלנו",
    reference: "משלי 3:13-18",
    category: "חוכמה",
    strongNumbers: {
      "חוכמה": "H2451", // חָכְמָה (chokmah) = חוכמה מעשית
      "תבונה": "H8394" // תְּבוּנָה (tebunah) = הבחנה
    },
    reflection: "כיצד אוכל ליישם את חוכמת אלוהים בהחלטותיי היום?"
  },
  {
    type: "tresor_divine",
    content: "אהבת אלוהים אינה מותנית בזכויותינו, אלא מתנה נצחית הזורמת ממהות אלוהים עצמו",
    reference: "רומים 8:38-39",
    category: "אהבה",
    strongNumbers: {
      "אהבה": "G26", // ἀγάπη (agape) = אהבה ללא תנאי
      "להפריד": "G5563" // χωρίζω (chorizo) = להפריד
    },
    reflection: "שום דבר לא יכול להפריד אותנו מאהבת אלוהים שבמשיח"
  },
  {
    type: "lumiere_vie",
    content: "ישוע אינו רק דרכנו, אלא האור המאיר את הוויתנו הפנימית",
    reference: "יוחנן 8:12",
    category: "זהות",
    strongNumbers: {
      "אור": "G5457", // φῶς (phos) = אור
      "חיים": "G2222" // ζωή (zoe) = חיים שופעים
    },
    reflection: "כיצד אתן לאור המשיח להאיר את אזורי החושך שלי?"
  },
  {
    type: "force_divine",
    content: "כוחנו לא בא מעצמנו, אלא ממי ששוכן בתוכנו",
    reference: "אפסים 3:16-17",
    category: "כוח",
    strongNumbers: {
      "יחזק": "G2901", // κραταιόω (krataioo) = מחזק
      "כוח": "G1411" // δύναμις (dynamis) = כוח אלוהי
    },
    reflection: "האם אני בוטח בכוחו של אלוהים ברגעי החולשה שלי?"
  },
  {
    type: "paix_profonde",
    content: "שלום אלוהים אינו תלוי בנסיבות החיצוניות, אלא בנוכחות המתמשכת של אלוהים בלבבותינו",
    reference: "פיליפים 4:6-7",
    category: "שקט",
    strongNumbers: {
      "שלום": "G1515", // εἰρήνη (eirene) = שלום מלא
      "ישמור": "G5432" // φρουρέω (phroureo) = שומר כמבצר
    },
    reflection: "כיצד אטפח את שלום אלוהים שהוא מעל כל שכל?"
  },
  {
    type: "esperance_vivante",
    content: "תקוותנו אינה משאלה לא ודאית, אלא עוגן איתן המבוסס על הבטחותיו הנאמנות של אלוהים",
    reference: "עברים 6:19",
    category: "תקווה",
    strongNumbers: {
      "תקווה": "G1680", // ἐλπίς (elpis) = תקווה בטוחה
      "עוגן": "G45" // ἄγκυρα (ankyra) = עוגן הנפש
    },
    reflection: "באיזו הבטחה של אלוהים אעגן את תקוותי היום?"
  },
  {
    type: "transformation",
    content: "התמרה רוחנית היא תהליך מתמשך, ואנו הופכים מדי יום יותר דומים לדמות המשיח",
    reference: "2 קורינתים 3:18",
    category: "צמיחה",
    strongNumbers: {
      "נהפכים": "G3339", // μεταμορφόω (metamorphoo) = מתמרה לחלוטין
      "כבוד": "G1391" // δόξα (doxa) = כבוד אלוהי
    },
    reflection: "איזה תחום בחיי זקוק להתמרה היום?"
  }
];

export default bibleTreasuresHe;
